import React from 'react';
import { TableHeaderRow } from '@devexpress/dx-react-grid-bootstrap4';

const TableHeaderCell = ({ ...restProps }) => {
    let classes;
    if (restProps.column.name === 'name') {
        classes = 'padding-left-10px ';
    }
    return <TableHeaderRow.Cell {...restProps} className={classes} />;
};

export default TableHeaderCell;
